import React from 'react';
import { Label, MaskedField, ErrorMessage } from '../FormikCustom';

export default function MaskedInput({ name, label, mask,  ...rest }) {
  return (
    <div className="form-group">
      <Label htmlFor={name}>{label}</Label>
      <MaskedField
        mask={mask}
        className="form-control"
      
        name={name}
        {...rest}
      />
      <ErrorMessage name={name} />
    </div>
  );
}
